import { Grid } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ConfirmationDialogResult, RecordEmployeeType, RecordUserAttachmentCategory, UserType } from "ui/Scripts/source/models/enums";
import { IRecordFurtherEducationGroupNode } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNode";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { SaveAttachmentBase64 } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/common/saveAttachmentBase64";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { IRecordEdit } from "../../../models/record/recordEdit";
import { IRecordEditItem } from "../../../models/record/recordEditItem";
import { IRecordEditItemEmployment } from "../../../models/record/recordEditItemEmployment";
import { IRecordEditItemFamiliarization } from "../../../models/record/recordEditItemFamiliarization";
import { IRecordEditItemFurtherEducation, RecordEditItemFurtherEducation } from "../../../models/record/recordEditItemFurtherEducation";
import { IRecordEditItemQualification, RecordEditItemQualification } from "../../../models/record/recordEditItemQualification";
import { IRecordEditItemTransferredProperty } from "../../../models/record/recordEditItemTransferredProperty";
import { IRecordEducationListItem } from "../../../models/recordEducation/recordEducationListItem";
import { IRecordFamiliarizationListItem } from "ui/Scripts/source/models/recordFamiliarization/recordFamiliarizationListItem";
import * as recordService from "../../../models/services/recordService";
import { ISessionState } from "../../../models/session/sessionState";
import { IUserListItem } from "../../../models/user/userListItem";
import { GridRow } from "../../framework/Grid/GridRow";
import { SelectUnitDialog } from "../../framework/Unit/SelectUnitDialog";
import { SelectUserDialog } from "../../user/SelectUserDialog/SelectUserDialog";
import { UserDialogMenuItem, UserEditDialog } from "../../user/UserEditDialog/UserEditDialog";
import { RecordEditAttachmentList } from "./RecordEditAttachmentList";
import { RecordEditAttachmentSubList } from "./RecordEditAttachmentSubList";
import { RecordEditBasicInformation } from "./RecordEditBasicInformation";
import { RecordEditEducation } from "./RecordEditEducation";
import { RecordEditFamiliarizationList } from "./RecordEditFamiliarizationList";
import { RecordEditLogList } from "./RecordEditLogList";
import { RecordEditNextOfKin } from "./RecordEditNextOfKin";
import { RecordEditQualificationList } from "./RecordEditQualificationList";
import { RecordEditSheetDataRowList } from "./RecordEditSheetDataRowList";
import { RecordEditTransferredPropertyList } from "./RecordEditTransferredPropertyList";
import { DialogSectionCard } from "../../framework/Dialog/DialogSectionCard";
import { RecordEditEmploymentList } from "./RecordEditEmploymentList/RecordEditEmploymentList";

/* eslint-disable no-unused-vars */
export const enum RecordEditViewMode {
    None = "",
    General = "1",
    Familiarization = "2",
    Education = "3",
    Employment = "4",
    NextOfKin = "5",
    Salary = "6",
    Attachments = "7",
    TransferredProperty = "8",
    Log = "9",
    Qualifications = "10",
}
/* eslint-enable no-unused-vars */

//RecordEdit
export interface IRecordEditProp {
    sessionState: ISessionState;
    recordEdit?: IRecordEdit;
    companyId: string;
    recordId: string;
    onDialog: boolean;
    viewMode: RecordEditViewMode;
    onRecordLoaded?: (recordEdit: IRecordEdit) => void;
    onRefreshSessionState: () => void;
    onEmploymentSaved?: () => void;
}

export interface IRecordEditState {
    isLoading: boolean;
    recordDataWasModified: boolean;
    canReadUsers: boolean;
    canEditUsers: boolean;
    canClearUnit: boolean;
    canArchiveAndRemove: boolean;
    isPartnerCompanyRecord: boolean;
    record: IRecordEditItem;
    pictureFile: IFileAttachment;
    copyPictureFromUser: boolean;
    resetPicture: boolean;
    units: IIdTitleNode[];
    workShiftNames: string[];
    // General
    id: string;
    rowId: string;
    unitId: string;
    unitCode: string;
    userId: string;
    userCode: string;
    firstName: string;
    middleName: string;
    lastName: string;
    picture: string;
    birthDate: string;
    postalAddress: string;
    postalCode: string;
    city: string;
    phone: string;
    email: string;
    employeeType: RecordEmployeeType;
    ibanNumber: string;
    bicCode: string;
    taxNumber: string;
    driversLicenseType: string;
    workShiftName: string;
    comment: string;
    orgActiveState: number;
    activeState: number;
    personalIdentityCode: string;
    identifier: string;
    nextOfKinFirstName: string;
    nextOfKinLastName: string;
    nextOfKinPostalAddress: string;
    nextOfKinPostalCode: string;
    nextOfKinCity: string;
    nextOfKinPhone: string;
    nextOfKinEmail: string;
    showSelectUserDialog: boolean;
    showUserDialog: boolean;
    userDialogUserId: string;
    userDialogDefaultMenuItem: UserDialogMenuItem;
    showSelectUnitDialog: boolean;
    // Familiarization
    familiarizations: IRecordFamiliarizationListItem[];
    recordFamiliarizations: IRecordEditItemFamiliarization[];
    familiarizationTrainers: string[];
    // Education
    basicEducations: IRecordEducationListItem[];
    //furtherEducations: IIdTitleNode[];
    furtherEducationGroups: IRecordFurtherEducationGroupNode[];
    basicEducationId: string;
    recordFurtherEducations: IRecordEditItemFurtherEducation[];
    // Qualification
    recordQualifications: IRecordEditItemQualification[];
    // Employment
    jobTitles: string[];
    recordEmployments: IRecordEditItemEmployment[];
    // TransferredProperty
    transferredPropertyTypes: string[];
    recordTransferredProperties: IRecordEditItemTransferredProperty[];
    // Attachments
    attachments: IFileAttachment[];
    // Salary
    sheetDataRows: ITaskDataRow[];
    taskType: ITaskEditTypeItem;
}

export class RecordEdit extends React.Component<IRecordEditProp, IRecordEditState> {
    private orgStateHash: string = "";

    getUsedStoragePercent = (usedFileStorageQuota: number, fileStorageQuota: number): number => {
        if (!usedFileStorageQuota || !fileStorageQuota) return 0;
        return usedFileStorageQuota > 0 ? Math.min(100, (usedFileStorageQuota / fileStorageQuota) * 100) : 0;
    };
 
    getStateFromRecordEdit = (oldState: IRecordEditState, recordEdit?: IRecordEdit): IRecordEditState => {
        const record = recordEdit.record;
        //const selectedUnitId = this.state.selectedUnitModuleNode?.id;
        return {
            ...oldState,
            record,
            pictureFile: null,
            resetPicture: !record.picture,
            units: recordEdit.units,
            canReadUsers: recordEdit.canReadUsers,
            canEditUsers: recordEdit.canEditUsers,
            canClearUnit: recordEdit.canClearUnit,
            canArchiveAndRemove: recordEdit.canArchiveAndRemove,
            isPartnerCompanyRecord: recordEdit.isPartnerCompanyRecord,
            workShiftNames: recordEdit.workShiftNames,
            // General
            id: record.id,
            rowId: record.rowId,
            unitId: record.unitId,
            unitCode: record.unitCode,
            userId: record.userId,
            userCode: record.userCode,
            firstName: record.firstName,
            middleName: record.middleName,
            lastName: record.lastName,
            picture: record.picture,
            birthDate: Base.utcTimeToDateStr(record.birthDate),
            postalAddress: record.postalAddress,
            postalCode: record.postalCode,
            city: record.city,
            phone: record.phone,
            email: record.email,
            employeeType: record.employeeType,
            ibanNumber: record.ibanNumber,
            bicCode: record.bicCode,
            taxNumber: record.taxNumber,
            driversLicenseType: record.driversLicenseType,
            workShiftName: record.workShiftName,
            comment: record.comment,
            orgActiveState: record.activeState,
            activeState: record.activeState,
            personalIdentityCode: record.personalIdentityCode,
            identifier: record.identifier,
            nextOfKinFirstName: record.nextOfKinFirstName,
            nextOfKinLastName: record.nextOfKinLastName,
            nextOfKinPostalAddress: record.nextOfKinPostalAddress,
            nextOfKinPostalCode: record.nextOfKinPostalCode,
            nextOfKinCity: record.nextOfKinCity,
            nextOfKinPhone: record.nextOfKinPhone,
            nextOfKinEmail: record.nextOfKinEmail,
            // Education
            basicEducations: recordEdit.basicEducations,
            furtherEducationGroups: recordEdit.furtherEducationGroups,
            //furtherEducations: RecordEdit.getFurtherEducations(recordEdit.furtherEducationGroups),
            basicEducationId: record.basicEducationId,
            recordFurtherEducations: record.furtherEducations,
            // Familiarization
            familiarizations: recordEdit.familiarizations,
            recordFamiliarizations: record.familiarizations,
            familiarizationTrainers: recordEdit.familiarizationTrainers,
            // Qualification
            recordQualifications: record.qualifications,
            // Employment
            jobTitles: recordEdit.jobTitles,
            recordEmployments: record.employments,
            // TransferredProperty
            transferredPropertyTypes: recordEdit.transferredPropertyTypes,
            recordTransferredProperties: record.transferredProperties,
            // Attachments
            attachments: recordEdit.attachments,
            // Salary
            sheetDataRows: record.sheetDataRows,
            taskType: recordEdit.taskType
        };
    };

    constructor(props: IRecordEditProp) {
        super(props);
        this.state = {
            isLoading: false,
            recordDataWasModified: false,
            canReadUsers: false,
            canEditUsers: false,
            canClearUnit: false,
            canArchiveAndRemove: false,
            isPartnerCompanyRecord: false,
            record: null,
            pictureFile: null,
            copyPictureFromUser: false,
            resetPicture: false,
            units: [],
            workShiftNames: [],
            // General
            id: "",
            rowId: "",
            unitId: "",
            unitCode: "",
            userId: "",
            userCode: "",
            firstName: "",
            middleName: "",
            lastName: "",
            picture: "",
            birthDate: "",
            postalAddress: "",
            postalCode: "",
            city: "",
            phone: "",
            email: "",
            employeeType: RecordEmployeeType.Employee,
            ibanNumber: "",
            bicCode: "",
            taxNumber: "",
            driversLicenseType: "",
            workShiftName: "",
            comment: "",
            nextOfKinFirstName: "",
            nextOfKinLastName: "",
            nextOfKinPostalAddress: "",
            nextOfKinPostalCode: "",
            nextOfKinCity: "",
            nextOfKinPhone: "",
            nextOfKinEmail: "",
            orgActiveState: 1,
            activeState: 1,
            personalIdentityCode: "",
            identifier: "",
            showSelectUserDialog: false,
            showUserDialog: false,
            userDialogUserId: "",
            userDialogDefaultMenuItem: UserDialogMenuItem.General,
            showSelectUnitDialog: false,
            // Attachments
            attachments: [],
            // Education
            basicEducations: [],
            furtherEducationGroups: [],
            basicEducationId: "",
            recordFurtherEducations: [],
            // Familiarization
            familiarizations: [],
            recordFamiliarizations: [],
            familiarizationTrainers: [],
            // Qualification
            recordQualifications: [],
            // Employment
            jobTitles: [],
            recordEmployments: [],
            // TransferredProperty
            transferredPropertyTypes: [],
            recordTransferredProperties: [],
            // Salary
            sheetDataRows: [],
            taskType: null
        };
        if (!props.recordEdit) return;
        this.state = this.getStateFromRecordEdit(this.state, props.recordEdit);
        this.updateStateHash();
    }

    loadRecord = async () => {
        const props = this.props;
        this.setState({ isLoading: true });
        const result = await AppUtils.callService(() => recordService.getRecordEdit(props.recordId, props.companyId), false, false, () => this.setState({ isLoading: false }));
        if (!result) return;
        const state = this.getStateFromRecordEdit(this.state, result);
        this.setState(state);
        await this.updateStateHash();
        if (props.onRecordLoaded) {
            props.onRecordLoaded(result);
        }
    };

    getRecord = (): IRecordEditItem => {
        return this.state.record;
    };
    
    getRecordDataWasModified = (): boolean => {
        return this.state.recordDataWasModified;
    };
    
    getRecordName = (): string => {
        const state = this.state;
        return state.record ? state.record.getName() : "";
    };

    cancel = async (doSave: boolean = true): Promise<ConfirmationDialogResult> => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel((await this.getSaveDataFromState(props, state)).hash, this.orgStateHash, null);
        if (doSave && cancelResult === ConfirmationDialogResult.Yes) {
            const saveResult = await this.saveToDb();
            if (!saveResult) return null;
        }
        return cancelResult;
    };

    canNavigateOut = async (): Promise<boolean> => {
        const cancelResult = await this.cancel(true);
        if (cancelResult === ConfirmationDialogResult.Cancel) return Base.getPromiseResult(false);
        return Base.getPromiseResult(true);
    };

    componentDidMount(): void {
        const props = this.props;
        if (props.recordEdit) {
            if (props.onRecordLoaded) {
                props.onRecordLoaded(props.recordEdit);
            }
            return;
        }
        this.loadRecord();
    }

    async componentDidUpdate(prevProps: IRecordEditProp, prevState: IRecordEditState): Promise<void> {
        const props = this.props;
        const state = this.state;
        if (prevProps.recordId === props.recordId) return;
        const cancelResult = await AppUtils.cancel((await this.getSaveDataFromState(props, state)).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            if (!await this.saveToDb()) return;
        }
        this.loadRecord();
    }

    handleChange = (name: string, value: string) => {
        if (!name) return;
        // General
        if (name === "firstName") {
            this.setState({ firstName: value });
        } else if (name === "middleName") {
            this.setState({ middleName: value });
        } else if (name === "lastName") {
            this.setState({ lastName: value });
        } else if (name === "postalAddress") {
            this.setState({ postalAddress: value });
        } else if (name === "postalCode") {
            this.setState({ postalCode: value });
        } else if (name === "city") {
            this.setState({ city: value });
        } else if (name === "phone") {
            this.setState({ phone: value });
        } else if (name === "email") {
            this.setState({ email: value });
        } else if (name === "birthDate") {
            this.setState({ birthDate: value });
        } else if (name === "taxNumber") {
            this.setState({ taxNumber: value });
        } else if (name === "ibanNumber") {
            this.setState({ ibanNumber: value });
        } else if (name === "bicCode") {
            this.setState({ bicCode: value });
        } else if (name === "driversLicenseType") {
            this.setState({ driversLicenseType: value });
        } else if (name === "employeeType") {
            this.setState({ employeeType: value.toInteger() });
        } else if (name === "workShiftName") {
            this.setState({ workShiftName: value });
        } else if (name === "comment") {
            this.setState({ comment: value });
        } else if (name === "activeState") {
            this.setState({ activeState: value.toInteger() });
        } else if (name === "personalIdentityCode") {
            this.setState({ personalIdentityCode: value });
        } else if (name === "identifier") {
            this.setState({ identifier: value });
        // Education
        } else if (name === "basicEducationId") {
            this.setState({ basicEducationId: value });
        // NextOfKin
        } else if (name === "nextOfKinFirstName") {
            this.setState({ nextOfKinFirstName: value });
        } else if (name === "nextOfKinLastName") {
            this.setState({ nextOfKinLastName: value });
        } else if (name === "nextOfKinPostalAddress") {
            this.setState({ nextOfKinPostalAddress: value });
        } else if (name === "nextOfKinPostalCode") {
            this.setState({ nextOfKinPostalCode: value });
        } else if (name === "nextOfKinCity") {
            this.setState({ nextOfKinCity: value });
        } else if (name === "nextOfKinPhone") {
            this.setState({ nextOfKinPhone: value });
        } else if (name === "nextOfKinEmail") {
            this.setState({ nextOfKinEmail: value });
        }
    };

    handleBlur = (name: string, value: string) => {
        if (!name) return;
        if (name === "birthDate") {
            this.setState({ birthDate: value ? Base.utcTimeToDateStr(value.toUtcDate().getTime()) : "" });
        } else if (name === "ibanNumber") {
            this.setState({ ibanNumber: Base.formatIbanNumber(value) });
        }
    };

    handleChangePicture = async (file: File) => {
        if (!file) return;
        const attachment = await FileAttachment.fileToFileAttachment(file, 0);
        if (!AppUtils.validateFileAttachment(attachment)) return;
        this.setState({
            pictureFile: attachment,
            resetPicture: false,
            picture: attachment.thumbnail
        });
    };

    handleRemovePicture = () => {
        this.setState({
            pictureFile: null,
            resetPicture: true,
            picture: ""
        });
    };

    handleRemoveUser = () => {
        this.setState({
            userId: "",
            userCode: ""
        });
    };

    handleRemoveUnit = () => {
        this.setState({
            unitId: "",
            unitCode: ""
        });
    };

    // #region Select User
    handleSelectUser = () => {
        this.setState({
            showSelectUserDialog: true
        });
    };

    onSelectUserDialogOk = async (users: IUserListItem[]) => {
        if (!users || users.length < 1) return;
        const user = users[0];
        if (!user) return;
        const pictureFile = user.defaultPictureInUse ? null : await FileAttachment.photoToFileAttachment(user.picture, 0);
        this.setState({
            showSelectUserDialog: false,
            userId: user.id,
            userCode: user.code,
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            picture: user.picture,
            resetPicture: user.defaultPictureInUse,
            pictureFile
        });
    };

    onSelectUserDialogCancel = () => {
        this.setState({
            showSelectUserDialog: false
        });
    };
    // #endregion Select User

    // #region User Dialog
    handleAddUser = () => {
        const state = this.state;
        if (!state.firstName) {
            AppUtils.showErrorMessage(Translations.FirstNameMustBeDefined);
            return;
        }
        if (!state.lastName) {
            AppUtils.showErrorMessage(Translations.LastNameMustBeDefined);
            return;
        }
        this.setState({
            showUserDialog: true,
            userDialogUserId: Base.emptyGuid,
            userDialogDefaultMenuItem: UserDialogMenuItem.General
        });
    };

    handleEditUser = () => {
        const state = this.state;
        if (!state.userId) return;
        this.setState({
            showUserDialog: true,
            userDialogUserId: state.userId,
            userDialogDefaultMenuItem: UserDialogMenuItem.General
        });
    };
    
    handleUserDialogOk = (userId: string, userCode: string) => {
        this.setState({
            showUserDialog: false,
            userId,
            userCode
        });
    };

    handleUserDialogCancel = () => {
        this.setState({
            showUserDialog: false
        });
    };

    handleUserDialogNewSaved = (userId: string, userCode: string) => {
        this.setState({
            showUserDialog: true,
            userId,
            userCode,
            userDialogUserId: userId,
            userDialogDefaultMenuItem: UserDialogMenuItem.UserGroups
        });
    };
    // #endregion User Dialog

    // #region Select Unit
    handleSelectUnit = () => {
        this.setState({
            showSelectUnitDialog: true
        });
    };

    handleSelectUnitDialogOk = async (node: IIdTitleNode) => {
        if (!node) return;
        this.setState({
            showSelectUnitDialog: false,
            unitId: node.id,
            unitCode: node.title
        });
    };

    handleSelectUnitDialogCancel = () => {
        this.setState({
            showSelectUnitDialog: false
        });
    };
    // #endregion Select Unit

    // #region Familiarization
    handleFamiliarizationRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        this.setState({
            recordFamiliarizations: this.state.recordFamiliarizations.filter(i => ids.indexOf(i.id) < 0),
            recordDataWasModified: true
        });
    };

    handleFamiliarizationSaved = (recordFamiliarization: IRecordEditItemFamiliarization) => {
        if (!recordFamiliarization) return;
        const recordFamiliarizations = this.state.recordFamiliarizations.filter(i => i.id !== recordFamiliarization.id);
        recordFamiliarizations.push(recordFamiliarization);
        this.setState({
            recordFamiliarizations,
            recordDataWasModified: true
        });
    };
    // #endregion Familiarization

    // #region Education
    handleFurherEducationRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        const recordFurtherEducations = this.state.recordFurtherEducations.filter(i => ids.indexOf(i.id) < 0);
        const recordQualifications = this.state.recordQualifications.slice(0);
        RecordEditItemQualification.setFurtherEducationCodes(recordQualifications, this.state.furtherEducationGroups, recordFurtherEducations);
        RecordEditItemFurtherEducation.setQaulificationsValidity(recordFurtherEducations, recordQualifications);
        this.setState({
            recordQualifications,
            recordFurtherEducations,
            recordDataWasModified: true
        });
    };

    handleFurherEducationSaved = (recordFurtherEducation: IRecordEditItemFurtherEducation) => {
        if (!recordFurtherEducation) return;
        const recordFurtherEducations = this.state.recordFurtherEducations.filter(i => i.id !== recordFurtherEducation.id);
        recordFurtherEducations.push(recordFurtherEducation);
        const recordQualifications = this.state.recordQualifications.slice(0);
        RecordEditItemQualification.setFurtherEducationCodes(recordQualifications, this.state.furtherEducationGroups, recordFurtherEducations);
        RecordEditItemFurtherEducation.setQaulificationsValidity(recordFurtherEducations, recordQualifications);
        this.setState({
            recordQualifications,
            recordFurtherEducations,
            recordDataWasModified: true
        });
    };
    // #endregion Education

    // #region Qualification
    handleQualificationRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        const recordQualifications = this.state.recordQualifications.filter(i => ids.indexOf(i.id) < 0);
        const recordFurtherEducations = this.state.recordFurtherEducations.slice(0);
        RecordEditItemQualification.setFurtherEducationCodes(recordQualifications, this.state.furtherEducationGroups, recordFurtherEducations);
        RecordEditItemFurtherEducation.setQaulificationsValidity(recordFurtherEducations, recordQualifications);
        this.setState({
            recordQualifications,
            recordFurtherEducations,
            recordDataWasModified: true
        });
    };

    handleQualificationSaved = (recordQualification: IRecordEditItemQualification) => {
        if (!recordQualification) return;
        const recordQualifications = this.state.recordQualifications.filter(i => i.id !== recordQualification.id);
        recordQualifications.push(recordQualification);
        const recordFurtherEducations = this.state.recordFurtherEducations.slice(0);
        RecordEditItemQualification.setFurtherEducationCodes(recordQualifications, this.state.furtherEducationGroups, recordFurtherEducations);
        RecordEditItemFurtherEducation.setQaulificationsValidity(recordFurtherEducations, recordQualifications);
        this.setState({
            recordQualifications,
            recordFurtherEducations,
            recordDataWasModified: true
        });
    };
    // #endregion Qualification

    // #region Employments
    handleEmploymentRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        this.setState({
            recordEmployments: this.state.recordEmployments.filter(i => ids.indexOf(i.id) < 0),
            recordDataWasModified: true
        });
    };

    handleEmploymentSaved = (employment: IRecordEditItemEmployment) => {
        if (!employment) return;
        const props = this.props;
        const state = this.state;
        const recordEmployments = this.state.recordEmployments.filter(i => i.id !== employment.id);
        recordEmployments.push(employment);
        const jobTitles = state.jobTitles.filter(i => i !== employment.jobTitle);
        jobTitles.push(employment.jobTitle);
        jobTitles.sort();
        this.setState({
            jobTitles,
            recordEmployments,
            recordDataWasModified: true
        });
        if (!props.onEmploymentSaved) return;
        props.onEmploymentSaved();
    };
    // #endregion Employments

    // #region TransferredProperties
    handleTransferredPropertyRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        this.setState({
            recordTransferredProperties: this.state.recordTransferredProperties.filter(i => ids.indexOf(i.id) < 0),
            recordDataWasModified: true
        });
    };

    handleTransferredPropertySaved = (item: IRecordEditItemTransferredProperty) => {
        if (!item) return;
        const recordTransferredProperties = this.state.recordTransferredProperties.filter(i => i.id !== item.id);
        recordTransferredProperties.push(item);
        this.setState({
            recordTransferredProperties,
            recordDataWasModified: true
        });
    };
    // #endregion Employments

    // #region SheetData
    handleSheetDataRowRemoved = (ids: string[], rowId: string) => {
        if (!ids || ids.length < 1) return;
        this.setState({
            sheetDataRows: this.state.sheetDataRows.filter(i => ids.indexOf(i.id) < 0),
            rowId,
            recordDataWasModified: true
        }, this.updateStateHash);
    };

    handleSheetDataRowSaved = (sheetDataRow: ITaskDataRow, rowId: string) => {
        if (!sheetDataRow) return;
        const sheetDataRows = this.state.sheetDataRows.filter(i => i.id !== sheetDataRow.id);
        sheetDataRows.push(sheetDataRow);
        this.setState({
            sheetDataRows,
            rowId,
            recordDataWasModified: true
        }, this.updateStateHash);
    };
    // #endregion SheetData

    // #region Attachments
    getAttahmentsCount = (): number => {
        return this.state.attachments.length;
    };

    handleAttachmentsRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        this.setState({
            attachments: this.state.attachments.filter(i => ids.indexOf(i.id) < 0),
            recordDataWasModified: true
        });
    };

    handleAttachmentsAdded = (attachments: IFileAttachment[]) => {
        if (!attachments || attachments.length < 1) return;
        const newAttachments = this.state.attachments.concat(attachments);
        FileAttachment.sortFileAttachments(newAttachments);
        this.setState({
            attachments: newAttachments,
            recordDataWasModified: true
        });
    };
    // #endregion Attachments

    getSaveDataFromState = async (props: IRecordEditProp, state: IRecordEditState): Promise<SaveDataObj> => {
        const result = new SaveDataObj();
        result.append("id", state.id);
        result.append("companyId", props.companyId);
        result.append("rowId", state.rowId);
        result.append("userCode", state.userCode);
        result.append("unitId", !state.unitId ? null : state.unitId);
        result.append("firstName", state.firstName);
        result.append("middleName", state.middleName);
        result.append("lastName", state.lastName);
        result.append("postalAddress", state.postalAddress);
        result.append("postalCode", state.postalCode);
        result.append("city", state.city);
        result.append("phone", state.phone);
        result.append("email", state.email);
        result.append("employeeType", state.employeeType);
        result.append("birthDate", !state.birthDate ? null : state.birthDate.toUtcDate().getTime());
        result.append("ibanNumber", state.ibanNumber);
        result.append("bicCode", state.bicCode);
        result.append("taxNumber", state.taxNumber);
        result.append("comment", state.comment);
        result.append("driversLicenseType", state.driversLicenseType);
        result.append("workShiftName", state.workShiftName);
        result.append("changeActiveState", props.onDialog && !Base.equalInt(state.activeState, state.orgActiveState));
        result.append("activeState", state.activeState);
        result.append("personalIdentityCode", state.personalIdentityCode);
        result.append("identifier", state.identifier);
        result.append("nextOfKinFirstName", state.nextOfKinFirstName);
        result.append("nextOfKinLastName", state.nextOfKinLastName);
        result.append("nextOfKinPostalAddress", state.nextOfKinPostalAddress);
        result.append("nextOfKinPostalCode", state.nextOfKinPostalCode);
        result.append("nextOfKinCity", state.nextOfKinCity);
        result.append("nextOfKinPhone", state.nextOfKinPhone);
        result.append("nextOfKinEmail", state.nextOfKinEmail);
        result.append("basicEducationId", !state.basicEducationId ? null : state.basicEducationId);
        result.append("copyPictureFromUser", state.copyPictureFromUser);
        result.append("resetPicture", state.resetPicture);
        if (state.pictureFile) {
            result.append("pictureAttachments", await SaveAttachmentBase64.fromFileAttachments([state.pictureFile]));
        }
        return result;
    };

    updateStateHash = async () => {
        this.orgStateHash = (await this.getSaveDataFromState(this.props, this.state)).hash;
    };
    
    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (!state.firstName) {
                AppUtils.showErrorMessage(Translations.FirstNameMustBeDefined);
                return resolve(false);
            }
            if (!state.lastName) {
                AppUtils.showErrorMessage(Translations.LastNameMustBeDefined);
                return resolve(false);
            }
            if (!Base.isValidEmailAddress(state.email)) {
                AppUtils.showErrorMessage(Translations.EmailAddressMustBeValid);
                return resolve(false);
            }
            if (!!state.bicCode && !Base.isValidFinnishBicCode(state.bicCode)) {
                AppUtils.showErrorMessage(String.format(Translations.ParameterIsNotValidBankBICCode, state.bicCode));
                return resolve(false);
            }
            if (!!state.ibanNumber && !Base.isValidIbanNumber(state.ibanNumber)) {
                AppUtils.showErrorMessage(String.format(Translations.ParameterIsNotValidAccountIBANNumber, state.ibanNumber));
                return resolve(false);
            }
            if (state.employeeType > 98) {
                AppUtils.showErrorMessage(Translations.EmployeeTypeMustBeDefined);
                return resolve(false);
            }
            return resolve(true);
        });
    };
    
    saveToDb = async (activeState: number = null): Promise<string> => {
        const props = this.props;
        const state = this.state;
        if (!await AppUtils.validate(this.checkErrors)) return null;
        const newActiveState = activeState ?? state.activeState;
        const saveData = await this.getSaveDataFromState(props, { ...state, activeState: newActiveState });
        //Call server
        const result = await AppUtils.callService(() => recordService.saveRecordEdit(saveData.obj));
        if (!result) return null;
        //Update state and hash
        const stateChange = { id: result.id, rowId: result.rowId, activeState: newActiveState };
        this.orgStateHash = (await this.getSaveDataFromState(props, { ...state, ...stateChange })).hash;
        this.setState(stateChange);
        props.onRefreshSessionState();
        //Edit view
        if (!props.onDialog) {
            await this.loadRecord();
        }
        return result.id;
    };

    save = async () => {
        await this.saveToDb();
    };

    render() {
        const props = this.props;
        const state = this.state;
        if (!state.record) return null;
        const record = state.record;
        const isNew = record.isNew();
        const unclassifiedAttachments = state.attachments.filter(i => i.category === RecordUserAttachmentCategory.RecordUser);
        const familiarizationAttachments = state.attachments.filter(i => i.category === RecordUserAttachmentCategory.Familiarization);
        const furtherEducationAttachments = state.attachments.filter(i => i.category === RecordUserAttachmentCategory.FurtherEducation);
        const employmentAttachments = state.attachments.filter(i => i.category === RecordUserAttachmentCategory.Employment);
        const transferredPropertyAttachments = state.attachments.filter(i => i.category === RecordUserAttachmentCategory.TransferredProperty);
        return (
            <>
                {props.viewMode === RecordEditViewMode.General &&
                    <RecordEditBasicInformation
                        onDialog={props.onDialog}
                        canReadUsers={state.canReadUsers}
                        canEditUsers={state.canEditUsers}
                        canClearUnit={state.canClearUnit}
                        canArchiveAndRemove={state.canArchiveAndRemove}
                        isPartnerCompanyRecord={state.isPartnerCompanyRecord}
                        resetPicture={state.resetPicture}
                        record={record}
                        workShiftNames={state.workShiftNames}
                        // General
                        unitCode={state.unitCode}
                        userCode={state.userCode}
                        firstName={state.firstName}
                        middleName={state.middleName}
                        lastName={state.lastName}
                        picture={state.picture}
                        birthDate={state.birthDate}
                        postalAddress={state.postalAddress}
                        postalCode={state.postalCode}
                        city={state.city}
                        phone={state.phone}
                        email={state.email}
                        employeeType={state.employeeType}
                        ibanNumber={state.ibanNumber}
                        bicCode={state.bicCode}
                        taxNumber={state.taxNumber}
                        driversLicenseType={state.driversLicenseType}
                        workShiftName={state.workShiftName}
                        comment={state.comment}
                        activeState={state.activeState}
                        personalIdentityCode={state.personalIdentityCode}
                        identifier={state.identifier}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        onChangePicture={this.handleChangePicture}
                        onRemovePicture={this.handleRemovePicture}
                        onAddUser={this.handleAddUser}
                        onEditUser={this.handleEditUser}
                        onSelectUser={this.handleSelectUser}
                        onRemoveUser={this.handleRemoveUser}
                        onSelectUnit={this.handleSelectUnit}
                        onRemoveUnit={this.handleRemoveUnit}
                    />
                }
                {props.viewMode === RecordEditViewMode.Familiarization &&
                    <RecordEditFamiliarizationList
                        sessionState={props.sessionState}
                        isReadOnly={isNew}
                        companyId={props.companyId}
                        recordId={record.id}
                        unitId={state.unitId}
                        userId={record.userId}
                        userCode={record.userCode}
                        familiarizationTrainers={state.familiarizationTrainers}
                        recordFamiliarizations={state.recordFamiliarizations}
                        familiarizations={state.familiarizations}
                        attachments={state.attachments}
                        onRemoved={this.handleFamiliarizationRemoved}
                        onSaved={this.handleFamiliarizationSaved}
                        onAttachmentsRemoved={this.handleAttachmentsRemoved}
                        onAttachmentsAdded={this.handleAttachmentsAdded}
                    />
                }
                {props.viewMode === RecordEditViewMode.Education &&
                    <RecordEditEducation
                        isNew={isNew}
                        companyId={props.companyId}
                        recordId={record.id}
                        userCode={record.userCode}
                        basicEducationId={state.basicEducationId}
                        recordQualifications={state.recordQualifications}
                        recordFurtherEducations={state.recordFurtherEducations}
                        basicEducations={state.basicEducations}
                        furtherEducationGroups={state.furtherEducationGroups}
                        attachments={state.attachments}
                        onChange={this.handleChange}
                        onFurherEducationRemoved={this.handleFurherEducationRemoved}
                        onFurherEducationSaved={this.handleFurherEducationSaved}
                        onAttachmentsRemoved={this.handleAttachmentsRemoved}
                        onAttachmentsAdded={this.handleAttachmentsAdded}
                    />
                }
                {props.viewMode === RecordEditViewMode.Qualifications &&
                    <RecordEditQualificationList
                        isReadOnly={isNew}
                        companyId={props.companyId}
                        recordId={record.id}
                        userCode={record.userCode}
                        recordFurtherEducations={state.recordFurtherEducations}
                        recordQualifications={state.recordQualifications}
                        furtherEducationGroups={state.furtherEducationGroups}
                        onRemoved={this.handleQualificationRemoved}
                        onSaved={this.handleQualificationSaved}
                    />
                }
                {props.viewMode === RecordEditViewMode.Employment &&
                    <RecordEditEmploymentList
                        isReadOnly={isNew}
                        companyId={props.companyId}
                        recordId={record.id}
                        userCode={record.userCode}
                        jobTitles={state.jobTitles}
                        employments={state.recordEmployments}
                        attachments={state.attachments}
                        onRemoved={this.handleEmploymentRemoved}
                        onSaved={this.handleEmploymentSaved}
                        onAttachmentsRemoved={this.handleAttachmentsRemoved}
                        onAttachmentsAdded={this.handleAttachmentsAdded}
                    />
                }
                {props.viewMode === RecordEditViewMode.NextOfKin &&
                    <RecordEditNextOfKin
                        record={record}
                        nextOfKinFirstName={state.nextOfKinFirstName}
                        nextOfKinLastName={state.nextOfKinLastName}
                        nextOfKinPostalAddress={state.nextOfKinPostalAddress}
                        nextOfKinPostalCode={state.nextOfKinPostalCode}
                        nextOfKinCity={state.nextOfKinCity}
                        nextOfKinPhone={state.nextOfKinPhone}
                        nextOfKinEmail={state.nextOfKinEmail}
                        onChange={this.handleChange}
                    />
                }
                {props.viewMode === RecordEditViewMode.Salary &&
                    <RecordEditSheetDataRowList
                        isReadOnly={isNew}
                        companyId={props.companyId}
                        recordId={record.id}
                        userCode={record.userCode}
                        rowId={state.rowId}
                        taskType={state.taskType}
                        taskDataRows={state.sheetDataRows}
                        onRowRemoved={this.handleSheetDataRowRemoved}
                        onRowSaved={this.handleSheetDataRowSaved}
                    />
                }
                {props.viewMode === RecordEditViewMode.Attachments &&
                    <GridRow sx={{ flexGrow: 2 }}>
                        <Grid item sm={12} md={6}>
                            <GridRow>
                                <Grid item sm={12} sx={{ marginBottom: "1rem" }}>
                                    <DialogSectionCard headerTitle={Translations.GeneralAttachments}>
                                        <RecordEditAttachmentList
                                            isDisabled={isNew}
                                            isDisabledMessage={Translations.NewRecordUserMustBeSavedBeforeAttachmentsCanBeAdded}
                                            companyId={props.companyId}
                                            recordId={record.id}
                                            userCode={record.userCode}
                                            margin={0}
                                            category={RecordUserAttachmentCategory.RecordUser}
                                            attachments={unclassifiedAttachments}
                                            onRemoved={this.handleAttachmentsRemoved}
                                            onAdded={this.handleAttachmentsAdded}
                                        />
                                    </DialogSectionCard>
                                </Grid>
                            </GridRow>
                            {familiarizationAttachments.length > 0 &&
                                <GridRow>
                                    <Grid item sm={12} sx={{ marginBottom: "1rem" }}>
                                        <DialogSectionCard headerTitle={Translations.Familiarizations}>
                                            <RecordEditAttachmentSubList
                                                isReadOnly={isNew}
                                                companyId={props.companyId}
                                                recordId={record.id}
                                                userCode={record.userCode}
                                                records={state.recordFamiliarizations}
                                                attachments={familiarizationAttachments}
                                                onRemoved={this.handleAttachmentsRemoved}
                                                onAdded={this.handleAttachmentsAdded}
                                            />
                                        </DialogSectionCard>
                                    </Grid>
                                </GridRow>
                            }
                            {furtherEducationAttachments.length > 0 &&
                                <GridRow>
                                    <Grid item sm={12} sx={{ marginBottom: "1rem" }}>
                                        <DialogSectionCard headerTitle={Translations.FurtherEducations}>
                                            <RecordEditAttachmentSubList
                                                isReadOnly={isNew}
                                                companyId={props.companyId}
                                                recordId={record.id}
                                                userCode={record.userCode}
                                                records={state.recordFurtherEducations}
                                                attachments={furtherEducationAttachments}
                                                onRemoved={this.handleAttachmentsRemoved}
                                                onAdded={this.handleAttachmentsAdded}
                                            />
                                        </DialogSectionCard>
                                    </Grid>
                                </GridRow>
                            }
                        </Grid>
                        <Grid item sm={12} md={6}>
                            {employmentAttachments.length > 0 &&
                                <GridRow>
                                    <Grid item sm={12} sx={{ marginBottom: "1rem" }}>
                                        <DialogSectionCard headerTitle={Translations.Employments}>
                                            <RecordEditAttachmentSubList
                                                isReadOnly={isNew}
                                                companyId={props.companyId}
                                                recordId={record.id}
                                                userCode={record.userCode}
                                                records={state.recordEmployments}
                                                attachments={employmentAttachments}
                                                onRemoved={this.handleAttachmentsRemoved}
                                                onAdded={this.handleAttachmentsAdded}
                                            />
                                        </DialogSectionCard>
                                    </Grid>
                                </GridRow>
                            }
                            {transferredPropertyAttachments.length > 0 &&
                                <GridRow>
                                    <Grid item sm={12} sx={{ marginBottom: "1rem" }}>
                                        <DialogSectionCard headerTitle={Translations.TransferredProperties}>
                                            <RecordEditAttachmentSubList
                                                isReadOnly={isNew}
                                                companyId={props.companyId}
                                                recordId={record.id}
                                                userCode={record.userCode}
                                                records={state.recordTransferredProperties}
                                                attachments={transferredPropertyAttachments}
                                                onRemoved={this.handleAttachmentsRemoved}
                                                onAdded={this.handleAttachmentsAdded}
                                            />
                                        </DialogSectionCard>
                                    </Grid>
                                </GridRow>
                            }
                        </Grid>
                    </GridRow>
                }
                {props.viewMode === RecordEditViewMode.TransferredProperty &&
                    <RecordEditTransferredPropertyList
                        isReadOnly={isNew}
                        companyId={props.companyId}
                        recordId={record.id}
                        userCode={record.userCode}
                        transferredPropertyTypes={state.transferredPropertyTypes}
                        items={state.recordTransferredProperties}
                        attachments={state.attachments}
                        onRemoved={this.handleTransferredPropertyRemoved}
                        onSaved={this.handleTransferredPropertySaved}
                        onAttachmentsRemoved={this.handleAttachmentsRemoved}
                        onAttachmentsAdded={this.handleAttachmentsAdded}
                    />
                }
                {props.viewMode === RecordEditViewMode.Log &&
                    <RecordEditLogList
                        companyId={props.companyId}
                        recordId={record.id}
                        userCode={record.userCode}
                    />
                }
                {state.showSelectUserDialog &&
                    <SelectUserDialog
                        companyId={props.companyId}
                        ignoreRecordUserConnected={true}
                        ignoreQrCodeUsers={true}
                        doNotIgnoreRecordUserConnectedUserCode={record.userCode}
                        onOk={this.onSelectUserDialogOk}
                        onCancel={this.onSelectUserDialogCancel}
                    />
                }
                {state.showUserDialog &&
                    <UserEditDialog
                        sessionState={props.sessionState}
                        companyId={props.companyId}
                        userId={state.userDialogUserId}
                        openedFromRecordUser={true}
                        recordUserPicture={state.picture}
                        recordUserFirstName={state.firstName}
                        recordUserLastName={state.lastName}
                        recordUserEmail={state.email}
                        defaultMenuItem={state.userDialogDefaultMenuItem}
                        userType={UserType.Normal}
                        hasPrevious={false}
                        hasNext={false}
                        onSaved={this.handleUserDialogOk}
                        onClose={this.handleUserDialogCancel}
                        onRefreshList={null}
                        onNewSaved={this.handleUserDialogNewSaved}
                        onPrevious={null}
                        onNext={null}
                        onRefreshSessionState={props.onRefreshSessionState}
                    />
                }
                {state.showSelectUnitDialog &&
                    <SelectUnitDialog
                        nodes={state.units}
                        title={Translations.SelectUnit}
                        firstColumnTitle={Translations.Unit}
                        selectedId={state.unitId}
                        onOk={this.handleSelectUnitDialogOk}
                        onCancel={this.handleSelectUnitDialogCancel}
                    />
                }
            </>
        );
    }
}